import { notification } from "antd";

const MessageHandler = () => {
  const error = (description) => {
    notification.error({
      message: "Failed",
      description,
    });
  };
  const warning = (description) => {
    notification.warning({
      message: "Info",
      description,
    });
  };
  const success = (description) => {
    notification.success({
      message: "Success",
      description,
    });
  };

  return {
    success,
    error,
    warning,
  };
};

export default MessageHandler();
